export default {
  backstage: 'BACKSTAGE',
  live: 'LIVE NOW',
};
